// extracted by mini-css-extract-plugin
module.exports = {"generalButton":"healthBook_generalButton__1Y1FC","progressBar":"healthBook_progressBar__P9eI6"};